<div class="activityEditRepaymentDialog" kalDialogContent>
    <div class="container">

        <app-shared-edit-repayment-schedule [editRepaymentSchedule]="data"
                                            [formControl]="repaymentScheduleControl">
        </app-shared-edit-repayment-schedule>

    </div>
</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">
            <kal-button (click)="submit()"
                        [disabled]="repaymentScheduleControl.invalid || loading"
                        id="activity_edit_repayment_schedule_dialog_submit"
                        kalTheme="primary">
                Enregistrer
            </kal-button>
        </div>

        <div class="gup-O-list__item">
            <kal-button (click)="cancel()"
                        id="activity_edit_repayment_schedule_dialog_cancel"
                        kalTheme="secondary">
                Annuler
            </kal-button>
        </div>

    </div>

</div>
